import React, {  ReactElement, ReactFragment, ReactNode } from 'react'
import { Container, Box, Paper, Typography, Divider, Stack, styled } from '@mui/material'
import { t } from 'i18next'
import { theme } from '../theme/maintheme'

const StyledContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1, 1),
  height: "100%",
  maxWidth: "false"
}));

const StyledContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  flexGrow: 1,
  flexShrink: 0,
  flexBasis: "400px",
  borderRadius: "10px",
  boxShadow: "0px 3px 15px #00000029",
  elevation: 1,
  position: "relative",
  height: "100%",
  [theme.breakpoints.between("xs", "sm")]: {
    maxWidth: "300px",
  },
  [theme.breakpoints.between("sm", "md")]: {
    maxWidth: "500px",
  },
  [theme.breakpoints.between("md", "lg")]: {
    maxWidth: "750px",
  },
  [theme.breakpoints.between("lg", "xl")]: {
    maxWidth: "100%",
  },
  [theme.breakpoints.up("xl")]: {
    maxWidth: "100%",
  },
}));

type ILayoutProps = {
  title: string;
  titleExtraComponent?: ReactNode;
  children: ReactElement | ReactFragment | boolean | null | undefined;
}

const InsideLayout = (props: ILayoutProps) => {
  const {title, children, titleExtraComponent} = props
  return (
    <StyledContainer >
      <StyledContent>
        <header style={{ marginBottom: 15 }}>
          <Typography variant="h4">{t(title)}</Typography>
        </header>
        <Box>
          {children}
        </Box>
      </StyledContent>
    </StyledContainer> 

)
}

export default InsideLayout